/*
 * Count-up for the Trust band numbers. When a .trust-band__num scrolls into
 * view, its leading number animates from 0 to its value, then the exact
 * original text is restored (so "+", "/ 5.0", thousands spaces are preserved).
 * Respects prefers-reduced-motion (numbers just render as-is, no animation).
 */
(function () {
  var nums = document.querySelectorAll('.trust-band__num');
  if (!nums.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function animate(el) {
    var full = el.textContent;
    var m = full.match(/(\d[\d\s]*(?:[.,]\d+)?)/); // first number token
    if (!m) return;
    var raw = m[1];
    var target = parseFloat(raw.replace(/\s/g, '').replace(',', '.'));
    if (isNaN(target)) return;
    var decimals = (raw.split(/[.,]/)[1] || '').length;
    var grouped = /\d\s\d/.test(raw); // uses spaces as thousands separators
    var prefix = full.slice(0, m.index);
    var suffix = full.slice(m.index + raw.length);
    var duration = 1100;
    var start = null;

    function format(v) {
      var s = decimals ? v.toFixed(decimals) : String(Math.round(v));
      if (grouped) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return prefix + s + suffix;
    }
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      if (p < 1) {
        el.textContent = format(target * eased);
        requestAnimationFrame(step);
      } else {
        el.textContent = full; // restore exact original
      }
    }
    requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6 });

  nums.forEach(function (n) { io.observe(n); });
})();
